<template>
  <login-header-element
    :is_forgot_password="is_forgot_password"
  />

  <v-main>
    <div class="background">
      <login-form-element
        :is_forgot_password="is_forgot_password"
        :toggle_forgot_password="toggleForgotPassword"
      />
    </div>
  </v-main>

  <login-footer-element
    v-if="!is_forgot_password"
  />
</template>

<script>
import LoginHeaderElement from '@/components/elements/logins/LoginHeaderElement.vue';
import LoginFormElement from '@/components/elements/logins/LoginFormElement.vue';
import LoginFooterElement from '@/components/elements/logins/LoginFooterElement.vue';

export default {
  name: 'LoginPage',
  components: {
    LoginHeaderElement,
    LoginFormElement,
    LoginFooterElement,
  },
  data() {
    return {
      is_forgot_password: this.$route.query['forgot-password'] === 'true',
    };
  },
  methods: {
    toggleForgotPassword() {
      this.is_forgot_password = !this.is_forgot_password;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';

main {
  height: calc(100% - 180px);
}
.background {
  background-image: url('@/assets/images/nomination-logo.svg');
  background-size: auto 75vh;
  background-position: bottom left;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  padding: 5%;
  display: flex;
}
</style>
